import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

import { DOMAIN_LIST_QUERY_KEY } from 'modules/queries/domain/useList';
import { TRANSFER_LIST_QUERY_KEY } from './useList';

interface SendEPPCodeParams {
	uniq_id: string;
}

const useSendEPPCode = () => {
	const queryClient = useQueryClient();

	return useMutation<unknown, ApiErrorI, SendEPPCodeParams>({
		mutationFn: (params) =>
			api.network.dns.domain.transfer.apiRaw.sendEPPCode(params),

		onSuccess: () => {
			toast.success('EPP code sent');

			queryClient.invalidateQueries([TRANSFER_LIST_QUERY_KEY]);
			queryClient.invalidateQueries([DOMAIN_LIST_QUERY_KEY]);
		},

		onError: () => {
			toast.danger('Failed to send EPP code');
		},
	});
};

export default useSendEPPCode;
